import { useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Zaim engineering components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import logoImage from "assets/images/logo_zaim_trans.png";
import apis from "../../../context/api";

function Basic() {
  const navitgate = useNavigate();
  const [rememberMe, setRememberMe] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    apis
      .login(username, password)
      .then((res) => {
        if (res && res.user && res.user.token) {
          let role = res.user.role.toLowerCase();
          localStorage.setItem("authToken", res.user.token);
          localStorage.setItem("userRole", role);
          setTimeout(() => {
            if (role === "admin") {
              navitgate("/dashboard");
            } else {
              navitgate("/quotation");
            }
            window.location.reload();
          }, 100);
        } else {
          alert("Login failed");
        }
      })
      .catch((err) => {
        alert("Login failed");
      });
  };

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox mx={2} mt={-3} p={2} mb={1} textAlign="center">
          <img
            src={logoImage}
            alt="logo"
            style={{
              width: "50%",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        </MDBox>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="email"
                value={username}
                label="Email"
                fullWidth
                onChange={(e) => setUsername(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                value={password}
                label="Password"
                fullWidth
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                type="submit"
                variant="gradient"
                color="info"
                fullWidth
                onClick={handleSubmit}
              >
                sign in
              </MDButton>
            </MDBox>
            {/*<MDBox mt={3} mb={1} textAlign="center">*/}
            {/*  <MDTypography variant="button" color="text">*/}
            {/*    Don&apos;t have an account?{" "}*/}
            {/*    <MDTypography*/}
            {/*      component={Link}*/}
            {/*      to="/authentication/sign-up"*/}
            {/*      variant="button"*/}
            {/*      color="info"*/}
            {/*      fontWeight="medium"*/}
            {/*      textGradient*/}
            {/*    >*/}
            {/*      Sign up*/}
            {/*    </MDTypography>*/}
            {/*  </MDTypography>*/}
            {/*</MDBox>*/}
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
